module.exports = __webpack_public_path__ + "img/face-3.03aaec1f.jpg";